{% block acris_edit_document_modal %}
    <sw-modal class="acris-edit-document-modal"
              :title="$tc('acris-edit-document-modal.title')"
              @modal-close="onCancel">

        {% block acris_edit_document_modal_form %}
            {% block acris_edit_document_modal_form_title %}
                <mt-text-field
                    :label="$tc('acris-edit-document-modal.field.title')"
                    :placeholder="$tc('acris-edit-document-modal.field.titlePlaceholder')"
                    v-model="documentItem.title">
                </mt-text-field>
            {% endblock %}
            {% block acris_edit_document_modal_form_description %}
                <mt-textarea
                    :label="$tc('acris-edit-document-modal.field.description')"
                    :placeholder="$tc('acris-edit-document-modal.field.descriptionPlaceholder')"
                    v-model="documentItem.description"
                    size="medium">
                </mt-textarea>
            {% endblock %}
            {% block acris_edit_document_modal_form_position %}
                <mt-number-field
                    :label="$tc('acris-edit-document-modal.field.position')"
                    :helpText="$tc('acris-edit-document-modal.field.positionHelpText')"
                    numberType="int"
                    v-model="documentItem.position"
                    disabled="disabled">
                </mt-number-field>
            {% endblock %}
            {% block acris_edit_document_modal_form_language %}
                <sw-entity-many-to-many-select
                    :label="$tc('acris-edit-document-modal.field.language')"
                    :placeholder="$tc('acris-edit-document-modal.field.languagePlaceholder')"
                    :helpText="$tc('acris-edit-document-modal.field.languageHelpText')"
                    :entity-collection="documentItem.languages"
                    @update:entity-collection="changeLanguageSelection">
                </sw-entity-many-to-many-select>
            {% endblock %}
        {% endblock %}

        {% block acris_edit_document_modal_footer %}
            <template #modal-footer>

                {% block acris_edit_document_modal_footer_button_cancel %}
                    <mt-button size="small" @click="onCancel" variant="secondary">
                        {{ $tc('global.default.cancel') }}
                    </mt-button>
                {% endblock %}

                {% block acris_edit_document_modal_footer_button_apply %}
                    <mt-button variant="primary" size="small" @click="onApply">
                        {{ $tc('global.default.apply') }}
                    </mt-button>
                {% endblock %}
            </template>
        {% endblock %}
    </sw-modal>
{% endblock %}
